import { appData } from '@/mocks/home';

export default function SectionApp() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 bg-accent-50 rounded-2xl p-6 md:p-10 border border-accent-100">
          <div className="flex-shrink-0">
            <div className="w-40 md:w-48">
              <img
                src={appData.image}
                alt="51吃瓜网APP移动端展示"
                className="w-full h-auto rounded-xl"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex-1 text-center md:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">移动端专属</span>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-3">{appData.title}</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">{appData.description}</p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
              {appData.features.map((f) => (
                <span key={f} className="flex items-center gap-1 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}